import { getCookie } from 'cookies-next';
import { MenuPageDataType } from '../../app/(routes)/online-ordering/types';
import { getVisibilityParams, removeEmptyKeys } from '../../utils/UtilFunctions';
import { endpoints } from '../core/apiConfig';
import client from '../core/Interceptor';

export const getCategoryItemsClient = async (id: number) => {
  const response = await client.get(`${endpoints.restaurant.categoryItems}/${id}/items`);
  return response.data;
};

export const getRestaurantReviews = async (
  restaurantId: number,
  page: number,
  pageSize: number,
  rating?: number,
  startDate?: string,
  endDate?: string
) => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });

  if (rating !== undefined && rating !== 0) params.append('rating', String(rating));
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);

  const response = await client.get(`${endpoints.feedback.getReviews}/${restaurantId}/review?${params.toString()}`);
  return response.data;
};

export const getRestaurantSettings = async (restaurantId: number) => {
  const response = await client.get(`${endpoints.restaurant.getOnlineSettings}/${restaurantId}`);
  return response.data;
};

export const getCategoryItemsByMenuClient = async (id: number, restaurantId: number, userId?: string) => {
  const visibilityParams = getVisibilityParams();
  const newObj = removeEmptyKeys({
    ...visibilityParams,
    restaurantId: JSON.stringify(restaurantId),
    userId: JSON.stringify(userId),
  });
  const response = await client.get(`${endpoints.restaurant.categoryItemsByMenu}/${id}`, {
    params: newObj,
  });
  return response.data;
};
export const prepareCart = async (prepareCartPayload: object) => {
  const response = await client.post(`${endpoints.restaurant.prepareCart}`, prepareCartPayload);
  return response.data;
};
export const reorderCart = async (object: object) => {
  const response = await client.post(endpoints.restaurant.reorderItems, object);
  return response.data;
};

export const getNearbyRestaurantLocationsOntype = async (
  restaurantId: number,
  latitude: number,
  longitude: number,
  orderType: string,
  maxDistanceAllowed: number
) => {
  const response = await client.get(
    `${endpoints.restaurant.getNearbyLocations}/${restaurantId}?` +
      `${orderType !== 'pickup-slot' ? `distance=${maxDistanceAllowed}&` : ''}` +
      `latitude=${latitude}&longitude=${longitude}&orderMode=restaurant&orderType=${orderType}`
  );
  return response.data;
};
export const getRestaurantTimings = async (restaurantId: number, type?: string) => {
  try {
    const url = `${endpoints.restaurant.getRestaurantTimings}/${restaurantId}${
      type ? `/?type=${encodeURIComponent(type)}` : ''
    }`;

    const response = await client.get(url);
    return response.data;
  } catch (error) {
    console.log(error, 'error from getRestaurantTimings ');
    return null;
  }
};
export const getRestaurantsClient = async (restaurantId: number) => {
  try {
    const userId = getCookie('sub') ?? '';
    const newObj = removeEmptyKeys({ userId });

    const response = await client.get(`${endpoints.restaurant.restaurant}/${restaurantId}`, {
      params: newObj,
    });
    return response.data;
  } catch (error: any) {
    console.log(error, 'error from getRestaurantsClient ');
    return null;
  }
};
export const reserveRestaurantTable = async (payload: object) => {
  const response = await client.patch(`${endpoints.table.reserveTable}`, payload);
  return response;
};

export const getRestaurantOnline = async (
  restaurantId: number,
  userId: string,
  menuId?: number,
  orderType?: string
): Promise<MenuPageDataType> => {
  const visibilityParams = getVisibilityParams();
  const payload: Record<string, any> = { userId, orderType, ...visibilityParams };
  if (menuId && Number.isInteger(menuId)) {
    payload['menuId'] = JSON.stringify(menuId);
  }
  const newObj = removeEmptyKeys(payload);

  const response = await client.get(`${endpoints.restaurant.getOnlineRestaurant}/${restaurantId}`, {
    params: newObj,
  });
  return response?.data?.data;
};

export const getQrDataClient = async (id: number) => {
  const response = await client.get(`${endpoints.qr.getQrData}/${id}`);
  return response?.data?.data;
};

export const getTipsSettings = async (restaurantId: number) => {
  const response = await client.get(`${endpoints.restaurant.getTipsSettings}`, {
    params: {
      restaurantId,
    },
  });

  return response?.data?.response?.data;
};

export const sendCapiEventClient = async ({
  restaurantId,
  businessId,
  eventName,
  eventId,
  customData,
  phone,
  email,
}: {
  restaurantId: number | undefined;
  eventName: string;
  eventId?: string;
  businessId: number;
  customData?: any;
  email?: string;
  phone?: string;
}) => {
  try {
    const fbp = getCookie('_fbp');
    const payload = {
      restaurantId,
      eventName,
      eventId,
      eventSourceUrl: window.location.href,
      phone,
      email,
      customData,
      businessId,
      fbp,
    };
    const response = await client.post(endpoints.restaurant.sendCapiEvent, payload);
    console.log('response', response);
    if (response?.statusText === 'skipped') {
      console.info('CAPI skipped: Meta Pixel not configured');
      return response?.data;
    }

    if (response?.statusText === 'failed') {
      console.warn('CAPI failed internally');
      return response?.data;
    }

    return response.data;
  } catch (error: any) {
    if (error?.response?.status >= 500) {
      console.error('CAPI server error', error.response);
    } else {
      console.warn('CAPI network issue', error.message);
    }
    return null;
  }
};
